import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function CogenerationTabs() {
  const { id } = useParams();
  const [overview, setOverview] = useState({});
  const [technical, setTechnical] = useState({});
  const [officials, setOfficials] = useState([]);
  const [performance, setPerformance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [overviewRes, techRes, officialsRes, perfRes] = await Promise.all([
          axios.get(`https://backend-zkgn.onrender.com/api/cogen/${id}`),
          axios.get(`https://backend-zkgn.onrender.com/api/cogen_technical/${id}`),
          axios.get(`https://backend-zkgn.onrender.com/api/cogen_officials/${id}`),
          axios.get(`https://backend-zkgn.onrender.com/api/performance/cogen/${id}`)
        ]);
        setOverview(overviewRes.data);
        setTechnical(techRes.data);
        setOfficials(officialsRes.data);
        setPerformance(perfRes.data);
      } catch (err) {
        setError("Failed to load cogeneration data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, [id]);

  if (loading) return <div className="text-center my-5">Loading...</div>;
  if (error) return <div className="text-danger my-5">{error}</div>;

  return (
    <div className="container my-5">
      {/* Tab headers */}
      <ul className="nav nav-tabs custom-tabs" id="cogenTab" role="tablist">
        <li className="nav-item">
          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#overview">Overview</button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#technical">Technical Info</button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#officials">Officials</button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#performance">Performance</button>
        </li>
      </ul>

      {/* Tab content */}
      <div className="tab-content p-4 border border-top-0 rounded-bottom shadow-sm" id="cogenTabContent">
        
        {/* Overview */}
        <div className="tab-pane fade show active" id="overview">
          <h4 className="mb-4">Overview</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr><th>Plant Name</th><td>{overview.cogen_plant_name}</td></tr>
                <tr><th>Address</th><td>{overview.plant_address}</td></tr>
                <tr><th>Contact Number</th><td>{overview.mobile_number}</td></tr>
                <tr><th>Email</th><td>{overview.email}</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Technical Info */}
        <div className="tab-pane fade" id="technical">
          <h4 className="mb-4">Technical Information</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr><th>Boiler Make</th><td>{technical.boiler_make}</td></tr>
                <tr><th>Boiler Capacity</th><td>{technical.boiler_capacity}</td></tr>
                <tr><th>Furnace Type</th><td>{technical.furnes_type}</td></tr>
                <tr><th>Fuel</th><td>{technical.fuel}</td></tr>
                <tr><th>Turbine Make</th><td>{technical.turbine_make}</td></tr>
                <tr><th>Turbine Capacity</th><td>{technical.turbine_capacity}</td></tr>
                <tr><th>Expansion</th><td>{technical.cogen_expansion}</td></tr>
                <tr><th>Capacity</th><td>{technical.cogen_capacity}</td></tr>
                <tr><th>Plant Make</th><td>{technical.cogen_plant_make}</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Officials */}
        <div className="tab-pane fade" id="officials">
          <h4 className="mb-4">Plant Officials</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr><th>Designation</th><th>Name</th><th>Mobile</th><th>Phone</th><th>Email</th></tr>
              </thead>
              <tbody>
                {officials.map((o) => (
                  <tr key={o.id}>
                    <td>{o.designation}</td>
                    <td>{o.officials_name}</td>
                    <td>{o.mobile_no}</td>
                    <td>{o.phone_number}</td>
                    <td>{o.officials_email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Performance */}
        <div className="tab-pane fade" id="performance">
          <h4 className="mb-4">Season-wise Performance</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr><th>Season</th><th>Bagasse Used</th><th>Power Generated</th><th>Power Exported</th><th>Operating Days</th></tr>
              </thead>
              <tbody>
                {performance.map((p, idx) => (
                  <tr key={idx}>
                    <td>{p.season}</td>
                    <td>{p.bgas_production}</td>
                    <td>{p.total_ecity_prod}</td>
                    <td>{p.total_ecity_export}</td>
                    <td>{p.working_days}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
}

export default CogenerationTabs;
